
const PageAbout = () => {
        return (
            <div className='pageAbout'>
              
            </div>
        )
    }
    
export default PageAbout